import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContentService } from '../../services/content/content.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment } from '../../services/environment/environment.token';

const content = require('./share.content.json');

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent {
  @Input()
  public mode: string = 'functie';

  @Input()
  public opleidingSlug: string;

  @Input()
  public functieSlug: string;

  @ViewChild('foo', { static: true, read: ElementRef })
  public foo: ElementRef;

  public constructor(
    private domSanitizer: DomSanitizer,
    private contentService: ContentService,
    private router: Router,
    private matSnackBar: MatSnackBar,
    @Inject(Environment) private environment: any
  ) {
    this.contentService.loadContent(content);
  }

  public shareWhatsapp(): SafeResourceUrl {
    const key = 'share.' + this.mode + '.whatsapp';
    let contentText: string = this.contentService.getContent(key);
    contentText += this.generateUrl();
    return this.domSanitizer.bypassSecurityTrustResourceUrl(contentText);
  }

  public shareMail(): SafeResourceUrl {
    const key = 'share.' + this.mode + '.email';
    let contentText: string = this.contentService.getContent(key);
    contentText += this.generateUrl();
    return this.domSanitizer.bypassSecurityTrustResourceUrl(contentText);
  }

  public generateUrl(): string {
    let url = this.environment.shareCallbackUri + '/';
    url += this.mode === 'functie' ? 'functie/' : 'opleiding/';
    url += this.mode === 'functie' ? this.functieSlug : this.opleidingSlug;
    return url;
  }

  public openPrintableScreen() {
    window.print();
  }

  public copyDeepLink() {
    const deepLink: string = this.environment.shareCallbackUri + this.router.url;
    const el: any = document.createElement('textarea');
    el.value = deepLink;
    el.setAttribute('readonly', '');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  public tooltipMaker(toolTipType: string) {
    const key = 'share.' + this.mode + '.tooltip.' + toolTipType;
    return this.contentService.getContent(key);
  }

  public linkCopiedPopup() {
    this.matSnackBar.open(this.generateUrl() + ' gekopieerd naar klipbord', '', { duration: 2000 });
  }
}
